<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M1.1,14.9a1.11,1.11,0,0,0,0,2.21H27.78l-8,8a1.1,1.1,0,0,0,1.56,1.56L32,16,21.34,5.32a1.11,1.11,0,1,0-1.56,1.57l8,8Z"
    />
</svg>
